import { Component } from '@angular/core';

@Component({
  selector: 'app-password-change-popup-dialog',
  templateUrl: './password-change-popup-dialog.component.html',
  styleUrls: ['./password-change-popup-dialog.component.scss']
})
export class PasswordChangePopupDialogComponent {

}
